<app-auth-layout>
    <app-h3>Reset Password</app-h3>

    <app-p>
        Please enter your email below. A reset password link will be sent to your email. Follow the link to enter a new password.
    </app-p>

    <form 
        *ngIf="stateService.formGroup$ | async as formGroup"
        [formGroup]="formGroup"
        (ngSubmit)="onSubmit()"
        tid="reset-password-form"
    >
        <div class="row">
            <div class="col-md-12 mb-3">
                <app-input
                    formPropertyName="emailAddress"
                    label="Email"
                    type="email"
                    placeholder="Enter your email address"
                    [requiredField]="true"
                    [emailField]="true"
                    tid="email-address"
                ></app-input>
            </div>
        </div>

        <div class="footer-actions">
            <div>   
                <app-button
                 tid="back-button" 
                 theme="alternate" 
                 [loading]="(stateService.state$ | async)?.inFlight" 
                 (click)="return()"
                >
                Back</app-button>
            </div>
            <div>
                <app-button
                 tid="submit-button"
                 theme="primary"
                 [loading]="(stateService.state$ | async)?.inFlight"
                 (click)="onSubmit()"
                >
                    Submit
                </app-button>
            </div>
        </div>
    </form>
</app-auth-layout> 